<div class="pill-container">
  <div
    class="pill"
    [class.hashed]="dashed"
    [style.background-color]="!dashed ? color : null"
    [style.border]="border"
  >
    <div class="pill-text" [style.color]="textColor">{{ status }}</div>
  </div>
</div>
